


























































































































































import Vue from "vue";
import iwModal from "@/shared/components/Modal.vue";
import iwButtonLoading from "@/shared/components/ButtonLoading.vue";
import iwSocialAuthentication from "@/shared/components/SocialAuthentication.vue";
import iwPassword from "iwb-serenity-password-vue-2";
import { Trans } from "../shared/scripts/helpers/translation/translation";
import {login} from "../shared/scripts/Authenticate";
import {BAD_CREDENTIALS, SUCCESS, USER_DATA_ERROR_RESET_PASSWORD} from "../shared/scripts/helpers/constants/payload";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";
import { mapState } from "vuex";

export default Vue.extend({
    components: {
        iwModal: iwModal,
        iwButtonLoading: iwButtonLoading,
        iwSocialAuthentication: iwSocialAuthentication,
        iwPassword: iwPassword,
    },

    props: {
        reload: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data: function() {
        return {
            error: "",
            loginEmail: "",
            password: "",
            isSubmitButtonDisabled:false,
            isSubscriptionDisplay: false,
            isInfoMessage: false,
        };
    },

    computed: {
        ...mapState("ModalModule", [
            "isLoginModalOpen",
            "canBeClosed",
            "loginModalSuccessCallback",
            "loginModalCancelCallback",
        ]),

        baseUrl: function(): string {
            return `${process.env.VUE_APP_IMMOWEB_URL}/${Trans.currentLocale}/`;
        },
        forgotPasswordUrl: function(): string {
            const forgotPasswordSlugs: Record<string,string> = {
                fr: "recuperation-mot-de-passe",
                nl: "wachtwoordherstel",
                en: "password-recovery",
            };

            return this.baseUrl + forgotPasswordSlugs[Trans.currentLocale];
        },
        privacyUrl: function(): string {
            const privacySlugs: Record<string,string> = {
                fr: "page/vie-privee",
                nl: "page/privacybeleid",
                en: "page/privacy",
            };

            return this.baseUrl + privacySlugs[Trans.currentLocale];
        },
        registerUrl: function(): string {
            const registerSlugs: Record<string,string> = {
                fr: "creer-compte",
                nl: "account-aanmaken",
                en: "create-account",
            };

            return this.baseUrl + registerSlugs[Trans.currentLocale];
        },
        proLoginUrl: function(): string {
            return process.env.VUE_APP_PRO + "/" + Trans.currentLocale;
        },
        resetImmowebUrl: function(): string {
            switch(Trans.currentLocale) {
            case "fr":
                return `${process.env.VUE_APP_IMMOWEB_URL}/fr/recuperation-mot-de-passe/reset-securite-confirmation?email=${this.loginEmail}`;
            case "nl":
                return `${process.env.VUE_APP_IMMOWEB_URL}/nl/wachtwoordherstel/security-bevestiging?email=${this.loginEmail}`;
            default:
                return `${process.env.VUE_APP_IMMOWEB_URL}/en/password-recovery/security-reset-confirmation?email=${this.loginEmail}`;
            }
        },
    },

    methods: {
        resetPassword: function() {
            this.password = "";
        },

        closeLoginModal: function() {
            this.resetPassword();

            if (this.loginModalCancelCallback) {
                this.loginModalCancelCallback();
            }

            if(this.canBeClosed) {
                this.$store.commit("ModalModule/closeLoginModal");
            }
        },
        openLoginModal: function() {
            this.$store.commit("ModalModule/openLoginModal");
        },
        loginUser: function() {
            this.isSubmitButtonDisabled = true;
            this.isInfoMessage = false;
            login(this.loginEmail, this.password).then(data => {
                this.isSubmitButtonDisabled = false;

                if (data === SUCCESS) {
                    if (this.loginModalSuccessCallback) {
                        this.loginModalSuccessCallback();
                        this.resetPassword();
                        this.$store.commit("ModalModule/closeLoginModal");
                    } else {
                        this.closeLoginModal();
                        if(this.reload) {
                            window.location.reload();
                        }
                    }
                } else if (data === BAD_CREDENTIALS) {
                    // bad login/password
                    this.error = "user_auth_00004_0";
                } else if (data === USER_DATA_ERROR_RESET_PASSWORD) {
                    this.isInfoMessage = true;
                    this.error = "password_has_been_reset";
                    window.location.replace(this.resetImmowebUrl);
                } else {
                    this.error = data;
                }
            }).catch(error => {
                this.dialog.alert(i18n.t("server_not_responding_error").toString());
                console.error(error);
            });
        },
    }
});

